var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeOpenBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03 18h33.94m-16.97 24c-4.42 0-8-8.06-8-18s3.58-18 8-18m0 24h-16.97",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42a18 18 0 0 1 0-36m13 25.65a12.46 12.46 0 0 1 5.97-1.65 1 1 0 0 1 1.03 1v8.1c0 .66-.5 1.2-1.16 1.24-2.06.02-4.08.6-5.84 1.66m0-10.35a12.46 12.46 0 0 0-5.97-1.65 1 1 0 0 0-1.03 1v8.34a1 1 0 0 0 1 1c2.11 0 4.19.57 6 1.66m0-10.35v10.35m-5-18c0-9.94-3.58-18-8-18",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 24a18 18 0 0 0-18-18",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeOpenBook);
export default __webpack_public_path__ + "static/media/globe-open-book.7d7c1e0ba359aa9119fddea06ed83ce6.svg";
export { ForwardRef as ReactComponent };